import { render, staticRenderFns } from "./BpSortMenu.vue?vue&type=template&id=6e5f903d&"
import script from "./BpSortMenu.vue?vue&type=script&lang=js&"
export * from "./BpSortMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports